// extracted by mini-css-extract-plugin
module.exports = {"root":"FooterLogos_root__8aDLR"};